import { UseFormSetValue } from "react-hook-form";
import { useLabelsContext } from "../../context/LabelsContext";
import { LoginFields } from "../../models/login-fields";
import { motion } from "framer-motion";
import { fadeScale } from "../../styles/MotionFramerAnimations";
import "../../styles/SwitchLoginType.scss";
import { LOGIN_METHODS, LoginMethod } from "../../models/login-methods";
import { AUTH_STEPS } from "../../models/auth-steps";
import { useAuthContext } from "../../context/AuthContext";
interface SwitchLoginTypeProps {
	setValue: UseFormSetValue<LoginFields>;
	loginMethod: LoginMethod;
	setLoginMethod: React.Dispatch<React.SetStateAction<LoginMethod>>;
	setCanSwitchLoginType: React.Dispatch<React.SetStateAction<boolean>>;
}

export const SwitchLoginType: React.FC<SwitchLoginTypeProps> = ({
	setValue,
	loginMethod,
	setLoginMethod,
	setCanSwitchLoginType,
}) => {
	const { labels } = useLabelsContext();
	const { setAuthStep } = useAuthContext();
	
	const switchLoginType = (): void => {
		setValue(loginMethod, "");
		setLoginMethod(
			loginMethod === LOGIN_METHODS.EMAIL
				? LOGIN_METHODS.PASSPORT
				: LOGIN_METHODS.EMAIL,
		);
		setCanSwitchLoginType(false);
		setAuthStep(AUTH_STEPS.PROFILE_RECOVERY);
	};

	return (
		<motion.button
			{...fadeScale}
			type='button'
			className='switch-login-type-btn'
			onClick={() => switchLoginType()}
		>
			{labels?.["MemberNotFoundByPassportText"] ||
				`חבר מועדון לא נמצא ע"פ תז, ננסה למצוא אותך במייל?`}
		</motion.button>
	);
};
